import React from 'react';
import Popup from "reactjs-popup";

const ViewError = (props) => {
    return (
        <Popup
            open={true}
            closeOnDocumentClick
            onClose={props.closeModal}
        >
            <div>
                <button className="close" onClick={props.closeModal}>  &times; </button>
                <div className="page-header"> <h1> {props.title} </h1> </div>
                <div className="alert alert-warning">{props.message} </div>
            </div>
        </Popup>
    );
}                

export default ViewError;